// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"593a4020","276":"593a4020","380":"593a4020","482":"593a4020","876":"593a4020"}[chunkId] + ".chunk.css";
};